<div class="popup platform-warpper">
    <!-- start popup-header -->
    <div class="popup-header">
        <h3>What's New in Vahana</h3>
        <p>New features, bug fixes, and content you might've missed.</p>
    </div>
    <!-- end popup-header -->

    <!-- Dynamic slide content -->
    <div class="popup-content d-block">
        <div class="image-column">
            <img [src]="currentSlide.image" alt="slide image">
        </div>
        <div class="platform-content">
            <span class="small-chip-outline">{{ currentSlide.tag }}</span>
            <h4>{{ currentSlide.title }}</h4>
            <p [innerHTML]="currentSlide.description"></p>

            <!-- Layout Type 1: Icon with title and description -->
            <div class="slider-vDesigner-new-1" *ngIf="currentSlide.layoutType === 'type-1'">
                <div class="list-box" *ngFor="let feature of currentSlide.features">
                    <img [src]="feature.icon" width="12" height="12" alt="icon">
                    <div>
                        <h5>{{ feature.title }}</h5>
                        <p>{{ feature.description }}</p>
                    </div>
                </div>
            </div>

            <!-- Layout Type 2: Card layout -->
            <div class="slider-vDesigner-new-2" *ngIf="currentSlide.layoutType === 'type-2'">
                <div class="card" *ngFor="let feature of currentSlide.features">
                    <p><strong>{{ feature.title }}:</strong> {{ feature.description }}</p>
                </div>
            </div>

            <!-- Layout Type 3: Numbered with colored headers -->
            <div class="slider-vDesigner-new-3" *ngIf="currentSlide.layoutType === 'type-3'">
                <div class="list-box" *ngFor="let feature of currentSlide.features; let i = index">
                    <h5 [class]="feature.iconClass">
                        <span class="num-txt" *ngIf="feature.numbered">{{ i + 1 }}</span>{{ feature.title }}
                    </h5>
                    <p>{{ feature.description }}</p>
                </div>
            </div>
        </div>
    </div>
    <!-- end dynamic slide content -->

    <!-- start popup-footer -->
    <div class="popup-footer">
        <button mat-stroked-button [style.visibility]="step === 1 ? 'hidden' : 'visible'" (click)="prev()">
            <span class="icon-box icon-va-navigate-before"></span>
            <span>Previous</span>
        </button>
        <div class="slide-pills">
            <span class="chip-slide center-flex">
                <span *ngFor="let slide of slides; let i = index" [class.prev-slide]="i < step - 1"
                    [class.next-slide]="i > step - 1">
                    <img *ngIf="i === step - 1" width="16" src="./assets/images/slide-dot.svg" alt="current slide">
                    <img *ngIf="i < step - 1" width="5" src="./assets/images/prev-icon.svg" alt="previous slide">
                    <img *ngIf="i > step - 1" width="5" src="./assets/images/next-icon.svg" alt="next slide">
                </span>
            </span>
        </div>
        <button mat-raised-button color="primary" (click)="next()">
            <span>{{ step === slides.length ? 'Close' : 'Next' }}</span>
            <span class="icon-va-navigate-next" *ngIf="step !== slides.length"></span>
        </button>
    </div>
</div>